export default {
  title: 'Feature-Flags',
  subtitle: 'Plattformfunktionen für {{company}} aktivieren oder deaktivieren.',
  no_company: 'Wähle ein Restaurant aus, um dessen Feature-Flags zu verwalten.',
  columns: {
    feature: 'Funktion',
    status: 'Status',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direkt)',
      description:
        'Ermöglicht diesem Restaurant, PayPal-Zahlungen direkt auf das eigene PayPal-Konto zu erhalten. Für Restaurants von Partnern, die über Foodamigos abgerechnet werden, standardmäßig aktiv; dort wird auch auf diese Zahlungen die Servicegebühr erhoben und der Plattformanteil dem Partner in Rechnung gestellt.',
    },
    vip_free_flyers: {
      name: 'Monatliche Gratis-Flyer',
      description:
        'Sendet diesem Restaurant jeden Monat automatisch 500 Promo-Flyer (Standard: aktiv für VIP- und Star-Status).',
    },
    custom_store_seo: {
      name: 'Individuelle Shop-SEO',
      description:
        'Ermöglicht diesem Restaurant, die individuellen SEO-Einstellungen für den Online-Shop zu verwalten.',
    },
    external_printer: {
      name: 'Externer Belegdrucker',
      description:
        'Ermöglicht diesem Restaurant, einen Netzwerk-Belegdrucker mit der Bestell-Terminal-App zu verbinden, anstatt den im Terminal integrierten Drucker zu nutzen.',
    },
    stripe_payment_element: {
      name: 'Stripe Payment Element im Checkout',
      description:
        'Das Stripe-Konto des Restaurants bestimmt, welche Zahlungsarten der Checkout anbietet. Erst aktivieren, wenn auf der Stripe-Plattform die Zahlungsarten für verbundene Konten eingerichtet sind.',
    },
  },
  toasts: {
    enabled: 'Funktion aktiviert.',
    disabled: 'Funktion deaktiviert.',
    error: 'Die Funktion konnte nicht aktualisiert werden. Bitte erneut versuchen.',
    load_error: 'Feature-Flags konnten nicht geladen werden.',
  },
};
